module.exports = __webpack_public_path__ + "static/media/ic_app_emulation.26faac46.svg";